import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Autoplay } from 'swiper/modules';

import { Link } from "react-router-dom";


export default function SliderTestimonial() {
    return (
        <>
            <Swiper
                slidesPerView={1}
                spaceBetween={10}

                autoplay={{
                    delay: 3500,
                    disableOnInteraction: false,
                }}
                breakpoints={{
                    '@0.00': {
                        slidesPerView: 1,
                        spaceBetween: 0,
                    },
                    '@0.75': {
                        slidesPerView: 1,
                        spaceBetween: 0,
                    },
                    '@1.00': {
                        slidesPerView: 1,
                        spaceBetween: 0,
                    },
                    '@1.50': {
                        slidesPerView: 3,
                        spaceBetween: 10,
                    },
                }}
                modules={[Autoplay]}
                className="mySwiper"
            >

                <SwiperSlide>
                    <div className="slick-slide slick-cloned"  >
                        <div>
                            <div className="col-xl-4 wow fadeInUp" style={{ width: '100%', display: 'inline-block', visibility: 'visible', animationName: 'fadeInUp' }}>
                                <div className="testimonial_2_item">
                                    <div className="img">
                                        <img src="assets/img/Profile.png" alt="img" className="img-fluid w-100" />
                                    </div>
                                    
                                    <span>
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                    </span>
                                    <p>"From GST filing to financial consulting, the Sewax team handled everything smoothly. Their expertise and transparent approach made the entire process stress-free. Excellent service and great customer support!"</p>
                                    <h4>Mr. Sasanka Kumar</h4>
                                    <h6>Business Owner</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="slick-slide slick-cloned"  >
                        <div>
                            <div className="col-xl-4 wow fadeInUp" style={{ width: '100%', display: 'inline-block', visibility: 'visible', animationName: 'fadeInUp' }}>
                                <div className="testimonial_2_item">
                                    <div className="img">
                                        <img src="assets/img/Profile.png" alt="img" className="img-fluid w-100" />
                                    </div>
                                    
                                    <span>
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                    </span>
                                    <p>"Our solar energy project was completed efficiently and within the promised timeline. The Sewax team provided expert consultation, quality installation, and excellent after-sales support. Highly satisfied!"</p>
                                    <h4>Mr. Abhishek Kumar</h4>
                                    <h6>Business Owner</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="slick-slide slick-cloned"  >
                        <div>
                            <div className="col-xl-4 wow fadeInUp" style={{ width: '100%', display: 'inline-block', visibility: 'visible', animationName: 'fadeInUp' }}>
                                <div className="testimonial_2_item">
                                    <div className="img">
                                        <img src="assets/img/Profile.png" alt="img" className="img-fluid w-100" />
                                    </div>
                                    
                                    <span>
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                    </span>
                                    <p>"Sewax Services helped us with company registration, GST compliance, and website development. Their one-stop business solutions saved us both time and effort. A trustworthy and reliable business partner."</p>
                                    <h4>Mr. Vikram Patel</h4>
                                    <h6>Business Owner</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="slick-slide slick-cloned"  >
                        <div>
                            <div className="col-xl-4 wow fadeInUp" style={{ width: '100%', display: 'inline-block', visibility: 'visible', animationName: 'fadeInUp' }}>
                                <div className="testimonial_2_item">
                                    <div className="img">
                                        <img src="assets/img/Profile.png" alt="img" className="img-fluid w-100" />
                                    </div>
                                    
                                    <span>
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                    </span>
                                    <p>"We hired Sewax Services for facility management and housekeeping services. Their staff is well-trained, punctual, and highly professional. The quality of service has exceeded our expectations."</p>
                                    <h4>Mr. Rahul Singh</h4>
                                    <h6>Business Owner</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="slick-slide slick-cloned"  >
                        <div>
                            <div className="col-xl-4 wow fadeInUp" style={{ width: '100%', display: 'inline-block', visibility: 'visible', animationName: 'fadeInUp' }}>
                                <div className="testimonial_2_item">
                                    <div className="img">
                                        <img src="assets/img/Profile.png" alt="img" className="img-fluid w-100" />
                                    </div>
                                    
                                    <span>
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                    </span>
                                    <p>"The property consulting service was excellent. They guided us through every step with complete transparency and helped us find the perfect investment. A trustworthy team with great expertise."</p>
                                    <h4>Mr. Amit Sharma</h4>
                                    <h6>Business Owner</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="slick-slide slick-cloned"  >
                        <div>
                            <div className="col-xl-4 wow fadeInUp" style={{ width: '100%', display: 'inline-block', visibility: 'visible', animationName: 'fadeInUp' }}>
                                <div className="testimonial_2_item">
                                    <div className="img">
                                        <img src="assets/img/Profile.png" alt="img" className="img-fluid w-100" />
                                    </div>
                                    
                                    <span>
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                    </span>
                                    <p>"Their manpower supply and maintenance services have significantly improved our daily operations. The team is reliable, efficient, and always ready to provide quick support whenever needed."</p>
                                    <h4>Mr. Vikram Patel</h4>
                                    <h6>Business Owner</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="slick-slide slick-cloned"  >
                        <div>
                            <div className="col-xl-4 wow fadeInUp" style={{ width: '100%', display: 'inline-block', visibility: 'visible', animationName: 'fadeInUp' }}>
                                <div className="testimonial_2_item">
                                    <div className="img">
                                        <img src="assets/img/Profile.png" alt="img" className="img-fluid w-100" />
                                    </div>
                                    
                                    <span>
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                    </span>
                                    <p>"I've been using their health and wellness products for several months and have seen noticeable improvements in my overall well-being. Excellent quality products backed by great customer service."</p>
                                    <h4>Mr. Amit Gupta</h4>
                                    <h6>Business Owner</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="slick-slide slick-cloned"  >
                        <div>
                            <div className="col-xl-4 wow fadeInUp" style={{ width: '100%', display: 'inline-block', visibility: 'visible', animationName: 'fadeInUp' }}>
                                <div className="testimonial_2_item">
                                    <div className="img">
                                        <img src="assets/img/Profile.png" alt="img" className="img-fluid w-100" />
                                    </div>
                                    
                                    <span>
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                    </span>
                                    <p>"Sewax Services helped us with company registration, GST filing, and website development. Their team was professional, responsive, and delivered everything on time. Highly recommended for business solutions."</p>
                                    <h4>Mr. Rajesh Sharma</h4>
                                    <h6>Business Owner</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>






            </Swiper>
        </>
    );
}
